// src/portal/PortalDecisionPanel.jsx
//
// PORTED from the mock's `.decision` — the gate line and the two decision
// buttons, laid out in the shared `.op-panel` vocabulary.
//
// ── THE SWAP IS IMPLEMENTED FROM THE RULE, NOT FROM THE DRAWING ────────────
//
// The mock draws exactly one state: two findings staged, Return solid orange,
// Approve a green outline. Its README names the rule and says the other half is
// "the one piece of state the mock doesn't show":
//
//   findings staged  ->  RETURN is primary (solid), APPROVE is the outline
//   nothing staged   ->  APPROVE becomes primary (solid), RETURN disables
//
// WHY THAT WAY ROUND. Primary marks the action the plan is ASKING FOR. With
// findings written and unsent, the plan is mid-return and leaving is the
// unfinished act; with nothing written, the reviewer has read it and had no
// objection, and approving is. A panel that always made Return primary would
// push every reviewer toward returning.
//
// The variants themselves were ported last commit and deliberately not wired;
// this is where they get wired. Neither control's logic changes — `variant`
// selects the trigger button's classes and nothing else.
import { stagedFindings } from "./portalFindingNumber";
import PortalReturnControl from "./PortalReturnControl";
import PortalApproveControl from "./PortalApproveControl";

const PRIMARY = "op-btn op-btn--decision op-btn--primary";
const OUTLINE = "op-btn op-btn--decision op-btn--ok";

export default function PortalDecisionPanel({ review, markup = [], mayApprove, onReturned, onApproved }) {
  const staged = stagedFindings(markup);
  const n = staged.length;
  const hasStaged = n > 0;

  return (
    <section className="op-panel" aria-label="Decision" data-testid="decision-panel">
      <div className="op-panel-head">
        <span className="op-label">DECISION</span>
        <span
          className="op-meta"
          data-testid="decision-gate"
          data-staged={String(n)}
        >
          {hasStaged
            ? `${n} finding${n === 1 ? "" : "s"} staged — a returned plan needs at least one`
            : "Nothing staged — a returned plan needs at least one finding"}
        </span>
      </div>

      <div className="op-panel-body gap-2">
        {/* ORDER IS THE MOCK'S: Return first, Approve second. The SWAP changes
            which one is solid, not which one is on the left — moving a button
            under a cursor that is already travelling toward it is its own
            defect. */}
        <PortalReturnControl
          planReviewId={review.id}
          markup={markup}
          onReturned={onReturned}
          variant={hasStaged ? PRIMARY : OUTLINE}
        />
        <PortalApproveControl
          planReviewId={review.id}
          mayApprove={mayApprove}
          onApproved={onApproved}
          variant={hasStaged ? OUTLINE : PRIMARY}
        />
      </div>
    </section>
  );
}
